import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types"
// import bell from '../../assets/images/header/bell.png'
import axios from 'axios';
const Touring_group_index = props => {
  const [state, setState] = useState({
    touring_group_join: props.touring_group_join,
    touring_group_progress: props.touring_group_progress,
    touring_group_new: props.touring_group_new,
    parent_touring_group_ids: props.parent_touring_group_ids,
    child_touring_group_ids: props.child_touring_group_ids,
  });

  // API呼び出しを行う関数
  // const fetchTouringGroupJoin = async () => {
  //   try {
  //     const response = await axios.get('/user_touring_groups'); // 適切なAPIエンドポイントに書き換えてください
  //     setState({
  //       ...state,
  //       touring_group_join: response.data,
  //       // touring_group_progress: response.data,
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // コンポーネントがマウントされたときにAPIからデータを取得する
  // useEffect(() => {
  //   fetchTouringGroupJoin();

  // }, []);

  const handleSubmit = async (touring_group, method) => {
    const url = method === "delete" ? `/user_touring_groups/${touring_group.id}` : '/user_touring_groups';
    let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    let currentPath = window.location.pathname;
    try {
      const response = await axios({
        method: method,
        url: url,
        data: {
          touring_group_id: touring_group.id,
          from_path: currentPath
        },
        headers: {
          'X-CSRF-Token': csrfToken
        }
      });

      if (method === 'delete' && response.status === 204) {
        const updatedTouringGroupJoin = state.touring_group_join.filter(group => group.id !== touring_group.id);
        const newTouringGroupNew = [...state.touring_group_new, touring_group];
        // "touring_date" に基づいて昇順に並び替え
        newTouringGroupNew.sort((a, b) => {
          // Dateオブジェクトとして解釈
          const dateA = new Date(a.touring_date);
          const dateB = new Date(b.touring_date);

          // 昇順なので a - b
          return dateA - dateB;
        });
        setState(prevState => ({
          ...prevState,
          touring_group_join: updatedTouringGroupJoin,
          touring_group_new: newTouringGroupNew
        }));

        const updatedChildTouringGroupIds = state.child_touring_group_ids.filter(id => id !== touring_group.id);
        setState(prevState => ({
          ...prevState,
          child_touring_group_ids: updatedChildTouringGroupIds
        }));
      } else if (method === 'post' && response.status === 200) {
        const newTouringGroupJoin = [...state.touring_group_join, touring_group];
        // "touring_date" に基づいて昇順に並び替え
        newTouringGroupJoin.sort((a, b) => {
          // Dateオブジェクトとして解釈
          const dateA = new Date(a.touring_date);
          const dateB = new Date(b.touring_date);

          // 昇順なので a - b
          return dateA - dateB;
        });
        const newTouringGroupNew = state.touring_group_new.filter(group => group.id !== touring_group.id);
        setState(prevState => ({
          ...prevState,
          touring_group_join: newTouringGroupJoin,
          touring_group_new: newTouringGroupNew
        }));

        const updatedChildTouringGroupIds = [...state.child_touring_group_ids];
        updatedChildTouringGroupIds.push(touring_group.id);
        setState(prevState => ({
          ...prevState,
          child_touring_group_ids: updatedChildTouringGroupIds
        }));
      }
      // }

      // Handle the response from the server
    } catch (error) {
      // Handle the error
    }
  }

  const cutStringByByte = (str, maxByte) => {
    let b = 0;
    let limitLen = 0;
    for (let i = 0; i < str.length; i++) {
      let c = str.charCodeAt(i);  // letを追加
      b += c < 128 ? 1 : 2;
      if (b > maxByte) break;
      limitLen = i + 1;
    }
    return str.substring(0, limitLen);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; // getMonthは0から始まるので1を加えます
    const day = date.getDate();
    const week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()]; // getDayは0(Sunday)-6(Saturday)の値を返します
    return `${month}/${day}(${week})`;
  }

  return (
    <React.Fragment>
      <div>
        <div className="touring-group-head">
          <h2>{props.touring_group_title_detail_join}</h2>
        </div>
        {state.touring_group_join && state.touring_group_join.length > 0 ? (
          state.touring_group_join.slice(0, 3).map((touring_group) => {

            const title = touring_group.touring_title;
            let max_bytesize;
            if (/^[^\x01-\x7E\xA1-\xDF]+$/.test(title)) {
              max_bytesize = 24;
            } else {
              max_bytesize = 22;
            }
            const limitedTitle = cutStringByByte(title, max_bytesize);

            return (
              <div className="touring-title index" key={touring_group.id}>
                <a href={`/touring_groups/${touring_group.id}`} className="touring-title-overlay" data-turbolinks={false}></a>
                <p className="index">
                  {limitedTitle}
                </p>
                <p className="touring-title-date">
                  {formatDate(touring_group.touring_date)}
                </p>


              {state.parent_touring_group_ids.includes(touring_group.id) && (
                <div className="touring-title-button yellow">
                    親
                </div>
              )}
              {state.child_touring_group_ids.includes(touring_group.id) && (
                <button onClick={() => handleSubmit(touring_group, 'delete')} className="touring-title-button blue">参加</button>
              )}
              {!state.child_touring_group_ids.includes(touring_group.id) && !state.parent_touring_group_ids.includes(touring_group.id) && (
                <button onClick={() => handleSubmit(touring_group, 'post')} className="touring-title-button red">不参加</button>
              )}
            </div>
          );
          })
          ) : (
          <div>
            <p>なし</p>
          </div>
        )}
        <a href={props.list_link_join} className={props.list_button_color_red}>{props.list_button_value_join}</a>
      </div>

      <div>
        <div className="touring-group-head">
          <h2>{props.touring_group_title_detail_progress}</h2>
        </div>
        {state.touring_group_progress && state.touring_group_progress.length > 0 ? (
          state.touring_group_progress.slice(0, 3).map((touring_group) => {

            const title = touring_group.touring_title;
            let max_bytesize;
            if (/^[^\x01-\x7E\xA1-\xDF]+$/.test(title)) {
              max_bytesize = 24;
            } else {
              max_bytesize = 22;
            }
            const limitedTitle = cutStringByByte(title, max_bytesize);

            return (
              <div className="touring-title index" key={touring_group.id}>
                <a href={`/touring_groups/${touring_group.id}`} className="touring-title-overlay" data-turbolinks={false}></a>
                <p className="index">
                  {limitedTitle}
                </p>
                <p className="touring-title-date">
                  {formatDate(touring_group.touring_date)}
                </p>


              {state.parent_touring_group_ids.includes(touring_group.id) && (
                <div className="touring-title-button yellow">
                    親
                </div>
              )}
              {state.child_touring_group_ids.includes(touring_group.id) && (
                <button onClick={() => handleSubmit(touring_group, 'delete')} className="touring-title-button blue">参加</button>
              )}
              {!state.child_touring_group_ids.includes(touring_group.id) && !state.parent_touring_group_ids.includes(touring_group.id) && (
                <button onClick={() => handleSubmit(touring_group, 'post')} className="touring-title-button red">不参加</button>
              )}
            </div>
          );
          })
          ) : (
          <div>
            <p>なし</p>
          </div>
        )}
        <a href={props.list_link_progress} className={props.list_button_color_yellow}>{props.list_button_value_progress}</a>
      </div>

      <div>
        <div className="touring-group-head">
          <h2>{props.touring_group_title_detail_new}</h2>
        </div>
        {state.touring_group_new && state.touring_group_new.length > 0 ? (
          state.touring_group_new.slice(0, 3).map((touring_group) => {

            const title = touring_group.touring_title;
            let max_bytesize;
            if (/^[^\x01-\x7E\xA1-\xDF]+$/.test(title)) {
              max_bytesize = 24;
            } else {
              max_bytesize = 22;
            }
            const limitedTitle = cutStringByByte(title, max_bytesize);

            return (
              <div className="touring-title index" key={touring_group.id}>
                <a href={`/touring_groups/${touring_group.id}`} className="touring-title-overlay" data-turbolinks={false}></a>
                <p className="index">
                  {limitedTitle}
                </p>
                <p className="touring-title-date">
                  {formatDate(touring_group.touring_date)}
                </p>


                {state.parent_touring_group_ids.includes(touring_group.id) && (
                  <div className="touring-title-button yellow">
                      親
                  </div>
                )}
                {state.child_touring_group_ids.includes(touring_group.id) && (
                  <button onClick={() => handleSubmit(touring_group, 'delete')} className="touring-title-button blue">参加</button>
                )}
                {!state.child_touring_group_ids.includes(touring_group.id) && !state.parent_touring_group_ids.includes(touring_group.id) && (
                  <button onClick={() => handleSubmit(touring_group, 'post')} className="touring-title-button red">不参加</button>
                )}
              </div>
            );
          })
          ) : (
          <div>
            <p>なし</p>
          </div>
        )}
        <a href={props.list_link_new} className={props.list_button_color_blue}>{props.list_button_value_new}</a>
      </div>
    </React.Fragment>
  );
}

Touring_group_index.propTypes = {
  touring_group_title_detail_join: PropTypes.string,
  touring_group_title_detail_progress: PropTypes.string,
  touring_group_title_detail_new: PropTypes.string,
  touring_group_join: PropTypes.array,
  touring_group_progress: PropTypes.array,
  touring_group_new: PropTypes.array,
  parent_touring_group_ids: PropTypes.array,
  child_touring_group_ids: PropTypes.array,
  list_link_join: PropTypes.string,
  list_link_progress: PropTypes.string,
  list_link_new: PropTypes.string,
  list_button_color_red: PropTypes.string,
  list_button_color_yellow: PropTypes.string,
  list_button_color_blue: PropTypes.string,
  list_button_value_join: PropTypes.string,
  list_button_value_progress: PropTypes.string,
  list_button_value_new: PropTypes.string,
};
export default Touring_group_index